module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "toc"
  }), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }), _vm._v(" "), _c('h2', {
    staticClass: "h2-1"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _vm._v("CONTENTS")]), _vm._v(" "), _c('p', {
    staticClass: "image2"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/ch.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "toc-1"
  }, [_c('a', {
    staticClass: "none",
    attrs: {
      "href": "#/xhtml/foreword"
    }
  }, [_vm._v("FOREWORD")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/l.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "none",
    attrs: {
      "href": "#/xhtml/introduction"
    }
  }, [_vm._v("INTRODUCTION")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "none",
    attrs: {
      "href": "#/xhtml/chapter_01"
    }
  }, [_vm._v("1 ANTEBELLUM BEGINNINGS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "none",
    attrs: {
      "href": "#/xhtml/chapter_02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2 A NEW START")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "none",
    attrs: {
      "href": "#/xhtml/chapter_03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3 A NEW CENTURY")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "none",
    attrs: {
      "href": "#/xhtml/chapter_04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4 ENTREPRENEUR EXTRAORDINAIRE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "none",
    attrs: {
      "href": "#/xhtml/chapter_05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5 ROLLER-COASTER RIDE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "none",
    attrs: {
      "href": "#/xhtml/chapter_06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6 A TUMULTUOUS DECADE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "none",
    attrs: {
      "href": "#/xhtml/chapter_07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7 COMING OF AGE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "none",
    attrs: {
      "href": "#/xhtml/chapter_08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8 POSTWAR METAMORPHOSIS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "none",
    attrs: {
      "href": "#/xhtml/chapter_09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9 MORE CHANGES")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "none",
    attrs: {
      "href": "#/xhtml/chapter_10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10 ANOTHER RENAISSANCE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "none",
    attrs: {
      "href": "#/xhtml/epilogue",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("EPILOGUE")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/l.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "none",
    attrs: {
      "href": "#/xhtml/references",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("REFERENCES")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "none",
    attrs: {
      "href": "#/xhtml/index",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("INDEX")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-218d4410","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 75
// module chunks = 0